module.exports = __webpack_public_path__ + "static/media/central-license-image.6688c0e3.webp";